<template lang="pug">
	.navigator-menu.flex-col.space-small
		template(v-if="items", v-for="item in items.filter(f => !f.hidden || !f.hidden())")
			.menu-item.flex-col.space(:class="{ active: activeItem && item.id === activeItem.id }", @click="activeItem = item; activeSubItem = null; emitChange(item)")
				.flex-row.space.align-center
					.icon.flex-col.align-center.center(v-if="item.icon")
						fas(:icon="item.icon")
					.name {{item.name}}	
			template(v-if="item.subItems")
				.sub-menu-item.flex-row.space.align-center(v-for="subItem in item.subItems.filter(f => !f.hidden || !f.hidden())", 
					@click="activeItem = item; activeSubItem = subItem; emitChange(activeSubItem)", :class="{ active: activeSubItem && activeSubItem.id === subItem.id }"
				)
					.icon.flex-col.align-center.center(v-if="subItem.icon")
						fas(:icon="subItem.icon", size="sm")
					.name {{subItem.name}}
</template>

<script>	

	export default {
		translationCategory: 'navigator-menu',
		name: 'navigator-menu',
		components: {			
		},
		props: ['items', 'activeItemId'],
		data() {
			return {
				activeItem: this.items[0],
				activeSubItem: null	
			};
		},
		watch: {
			activeItemId(v) {
				if (v != this.activeItem?.id) {
					this.activeItem = this.items.find(f => f.id === v || (f.subItems && f.subItems?.some(s => s.id === v)));
					this.activeSubItem = this.activeItem?.subItems?.find(s => s.id === v);
				}
			}
		},
		computed: {
			allItems() {				
				return this.items.reduce((res, item) => [...res, item, ...(item.subItems || [])], []);
			}
		},
		mounted() {	
			if (__DEBUG__)
				window.navigatorMenu = this;
			this.loadQueryTab();
		},
		methods: {
			loadQueryTab() {
				const tab = this.$route.query['tab'];
				if (tab) {
					const item = this.allItems.find(f => f.id === tab)
					if (item) {
						this.$emit('change', item?.id, item);
					}
				}
			},
			emitChange(item) {
				this.$emit('change', item?.id, item);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.navigator-menu {
		padding: 10px 20px 10px 10px;
		border-right: 1px solid rgba(0,0,0,0.05);

		.name {
			max-width: 140px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.menu-item {
			cursor: pointer;
			transition: 0.3s;
			padding: 5px 15px;
			border-radius: 4px;

			.icon {
				width: 25px;
			}

			&.active {
				background: $base-accent;
				color: $base-bg;
			}
		}

		.sub-menu-item {
			font-size: 12px;
			cursor: pointer;
			padding: 5px 10px;
			border-radius: 4px;
			margin-left: 23px;

			.icon {
				width: 15px;
			}

			&.active {
				font-weight: 600;
				color: $base-accent;
			}
		}
	}
</style>
 